import React, { FC, useState } from 'react';
import { Field, Toggle } from '@kontentino/ui';
import UtmTagBuilder from 'components/shared/UtmTagBuilder';

type Props = {
  value?: string;
  onChange?(url: string): void;
};

const SetUTMTagsForm: FC<Props> = (props) => {
  const [utmFormShown, setUtmFormShown] = useState(false);

  return (
    <div>
      <div className="tw-flex tw-items-center">
        <Field.Group>
          <Field.Label required>Set UTM tags</Field.Label>
          <Field.Caption>
            UTM code or tag is a simple snippet code that you can add to the end
            of a URL to track the performance of campaigns and content.
          </Field.Caption>
        </Field.Group>
        <div className="tw-ml-20">
          <Toggle
            onChange={() => setUtmFormShown(!utmFormShown)}
            checked={utmFormShown}
          />
        </div>
      </div>
      {utmFormShown && (
        <UtmTagBuilder
          value={props.value}
          onChange={props.onChange}
          className="tw-mt-4"
        />
      )}
    </div>
  );
};

export default SetUTMTagsForm;
